const dashboardTypes = ['SET_LOADING', 'SET_ALERT', 'DISMISS_ALERT'];

export default dashboardTypes;
